import styled from 'styled-components';
import COLORS from 'shared/constants/colors';
import { Link } from 'react-router-dom';

const Container = styled.div``;
const ProductImage = styled.div`
  width: 100%;
  max-width: 100%;
  max-height: 100vh;
  min-height: 0;
  min-width: 0;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
  list-style: none;
  padding: 0;
  z-index: 1;
`;

const DownloadResources = styled.div`
  column-gap: 10px;
  border-radius: 4px;
  padding: 1.5em 0em;
  @media (min-width: 1200px) {
    display: flex;
    justify-content: space-around;
    margin-bottom: 5em;
    background: none;
    box-shadow: 4px 4px 10px #d9d9d9, -4px -4px 10px #ffffff;
  }
`;
const ResourceLink = styled.div`
  background: none;
  margin: 0.5em auto;
  max-width: 100%;
  padding: 1em 0.5em;
  justify-content: flex-start;
  display: flex !important;
  min-height: 40px;
  cursor: pointer;
  @media (min-width: 1200px) {
    background: none;
    margin: 0;
    max-width: 100%;
    padding: 0;
  }
`;
const Detail = styled.a`
  margin-left: 5px;
  text-decoration: none;
`;

const StyledLink = styled(Link)`
  margin-left: 5px;
  text-decoration: none;
`;

const Name = styled.div`
  grid-area: title;
  margin: 0;
  font-weight: 700;
  color: ${COLORS.BLACK};
`;
const Download = styled.span`
  grid-area: caption;
  color: ${COLORS.BLACK};
`;

export {
  Container,
  ProductImage,
  DownloadResources,
  ResourceLink,
  Detail,
  Name,
  Download,
  StyledLink,
};
